// @flow
import BaseComponent from '../base_component/base_component'

export default class RoadshowCalendar extends BaseComponent {
    constructor(id: number, component_name: string, options: any) {
        super(id, component_name, options);
    }

    onLoad() {
        this.normaliseHeight();
    }

    normaliseHeight() {
        let rows = $(this.component).find('.simple-calendar>table>tbody>tr');
        let numRows = rows.length;
        rows.css('height', `calc((100vh - 221px) / ${numRows})`);
    }

    navigate(date: string) {
        this.setParam('roadshow_current_date', date);
        this.rerender();
    }

    showTooltip(id: string) {
        $(this.component).find(`.roadshow-event-tooltip[data-id="${id}"]`).show();
    }

    hideTooltip(id: string) {
        $(this.component).find(`.roadshow-event-tooltip[data-id="${id}"]`).hide();
    }
}